import { useRef } from "react";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const talentCards = [
  {
    role: "Product Designer",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur.",
    img: "/images/HireUsImage.jpg",
  },
  {
    role: "FrontEnd Developer",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur.",
    img: "/images/HireUsImage.jpg",
  },
  {
    role: "Backend Engineer",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas consectetur.",
    img: "/images/HireUsImage.jpg",
  },
];

export default function HireTalentSection() {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="bg-secondary py-12 xs:py-14 sm:py-16 lg:py-20 px-4 xs:px-6 sm:px-8 md:px-12 lg:px-14 xl:px-16 2xl:px-20">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-primary font-bold text-2xl xs:text-3xl sm:text-4xl lg:text-5xl leading-tight xs:leading-snug uppercase px-2 xs:px-4 sm:px-0">
          Hire Our Community Talents
        </h1>
        <p className="text-sm xs:text-base sm:text-lg lg:text-xl mt-3 sm:mt-4 lg:mt-6 text-gray-700 pt-4 sm:pt-6 pb-4 sm:pb-6 max-w-xs xs:max-w-sm sm:max-w-2xl lg:max-w-4xl xl:max-w-5xl mx-auto leading-relaxed px-2 xs:px-4 sm:px-0">
          Looking for skilled and passionate individuals to bring your tech
          projects to life? Our community is home to a diverse pool of talented
          developers, designers, data scientists, project managers, and more. By
          partnering with us, you gain access to a network of vetted
          professionals eager to contribute their expertise.
        </p>

        {/* <div className="relative mt-8 sm:mt-10 lg:mt-12 px-2 xs:px-4 sm:px-6 lg:px-8">
          <Slider ref={sliderRef} {...settings}>
            {talentCards.map((card, i) => (
              <div key={i} className="px-2 sm:px-3 lg:px-4">
                <div
                  className="bg-primary rounded-xl shadow-lg h-80 xs:h-96 sm:h-[400px] lg:h-[420px] border border-red-200 relative overflow-hidden text-left mx-auto max-w-sm transition-transform duration-300 hover:scale-105"
                  style={{
                    backgroundImage: `url(/images/background.png)`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className="text-white p-3 xs:p-4 sm:p-5 text-base xs:text-lg sm:text-xl font-bold leading-tight">
                    {card.role}
                  </div>

                  <div className="px-3 xs:px-4 sm:px-5 text-xs xs:text-sm sm:text-base text-gray-100 leading-relaxed">
                    {card.description}
                  </div>

                  <div className="absolute bottom-0 w-full h-32 xs:h-40 sm:h-44 lg:h-[180px]">
                    <img
                      src={card.img}
                      alt={`${card.role} preview`}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-black/40" />
                    <div className="absolute bottom-3 xs:bottom-4 w-full flex justify-center z-10">
                      <button className="bg-red-600 text-white w-20 xs:w-24 sm:w-[100px] py-2 xs:py-2.5 sm:py-3 text-xs xs:text-sm sm:text-base rounded-md hover:bg-red-700 hover:scale-105 transition-all duration-200 shadow-lg font-medium">
                        Hire
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>

          <div className="flex justify-center gap-4 xs:gap-5 sm:gap-6 mt-6 xs:mt-7 sm:mt-8">
            <button
              onClick={() => sliderRef.current?.slickPrev()}
              className="w-10 h-10 xs:w-11 xs:h-11 sm:w-12 sm:h-12 rounded-full border-2 border-red-500 flex items-center justify-center hover:bg-red-100 hover:border-red-600 transition-all duration-200 text-red-600 hover:text-red-700"
              aria-label="Previous slide"
            >
              <FaChevronLeft className="text-sm xs:text-base" />
            </button>
            <button
              onClick={() => sliderRef.current?.slickNext()}
              className="w-10 h-10 xs:w-11 xs:h-11 sm:w-12 sm:h-12 rounded-full border-2 border-red-500 flex items-center justify-center hover:bg-red-100 hover:border-red-600 transition-all duration-200 text-red-600 hover:text-red-700"
              aria-label="Next slide"
            >
              <FaChevronRight className="text-sm xs:text-base" />
            </button>
          </div>
        </div> */}

        <form className="relative animate-float mt-10 xs:mt-12 sm:mt-14 lg:mt-16 mx-auto w-full xs:w-11/12 sm:w-4/5 md:w-3/4 lg:w-3/5 xl:w-1/2 p-4 xs:p-5 sm:p-6 lg:p-8 bg-white rounded-2xl shadow-2xl border border-red-100 transition-all duration-300 hover:shadow-3xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 xs:gap-4 sm:gap-5 lg:gap-6">
            <div className="flex flex-col text-left">
              <label
                htmlFor="name"
                className="mb-1.5 xs:mb-2 text-primary font-medium text-sm xs:text-base"
              >
                Name
              </label>
              <input
                id="name"
                type="text"
                placeholder="Enter your name"
                className="w-full border border-gray-300 rounded-md p-2.5 xs:p-3 sm:p-3.5 text-sm xs:text-base focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400 transition-all duration-200"
              />
            </div>
            <div className="flex flex-col text-left">
              <label
                htmlFor="phone"
                className="mb-1.5 xs:mb-2 text-primary font-medium text-sm xs:text-base"
              >
                Phone Contact
              </label>
              <input
                id="phone"
                type="tel"
                placeholder="Enter phone number"
                className="w-full border border-gray-300 rounded-md p-2.5 xs:p-3 sm:p-3.5 text-sm xs:text-base focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400 transition-all duration-200"
              />
            </div>
          </div>

          <div className="flex flex-col text-left mt-3 xs:mt-4 sm:mt-5">
            <label
              htmlFor="email"
              className="mb-1.5 xs:mb-2 text-primary font-medium text-sm xs:text-base"
            >
              Email
            </label>
            <input
              id="email"
              type="email"
              placeholder="Enter your email"
              className="w-full border border-gray-300 rounded-md p-2.5 xs:p-3 sm:p-3.5 text-sm xs:text-base focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400 transition-all duration-200"
            />
          </div>

          <div className="flex flex-col text-left mt-3 xs:mt-4 sm:mt-5">
            <label
              htmlFor="description"
              className="mb-1.5 xs:mb-2 text-primary font-medium text-sm xs:text-base"
            >
              Project Description
            </label>
            <textarea
              id="description"
              placeholder="Brief description of your project requirements"
              rows="3"
              className="w-full border border-gray-300 rounded-md p-2.5 xs:p-3 sm:p-3.5 text-sm xs:text-base focus:outline-none focus:ring-2 focus:ring-red-400 focus:border-red-400 transition-all duration-200 resize-vertical min-h-[80px] xs:min-h-[90px] sm:min-h-[100px]"
            ></textarea>
          </div>

          <button
            type="submit"
            className="mt-5 xs:mt-6 sm:mt-8 w-full xs:w-80 sm:w-[309px] mx-auto bg-red-600 text-white py-3 xs:py-3.5 sm:py-4 text-sm xs:text-base font-medium rounded-[30px] hover:bg-red-700 hover:scale-105 transition-all duration-200 block shadow-lg"
          >
            Send a Project Request
          </button>
        </form>
      </div>
    </section>
  );
}
